import api from "@/utils/axios-utils";

export type FrontendCustomerIOEventName =
  | "login"
  | "lesson_started";

export type FrontendCustomerIOEventPayload = {
  event_name: FrontendCustomerIOEventName;
  user_id?: string;
  email?: string;
  occurred_at?: string;
  properties?: Record<string, unknown>;
};

export type CustomerIOEventAccepted = {
  accepted: boolean;
  owner: "frontend";
  event_name: FrontendCustomerIOEventName;
  forwarded: boolean;
};

export async function emitFrontendCustomerIOEvent(
  payload: FrontendCustomerIOEventPayload,
): Promise<CustomerIOEventAccepted> {
  const response = await api.post<CustomerIOEventAccepted>(
    "/customerio/events/frontend",
    payload,
    { skipAuthRedirect: true },
  );
  return response.data;
}

export async function safeEmitFrontendCustomerIOEvent(
  payload: FrontendCustomerIOEventPayload,
): Promise<CustomerIOEventAccepted | null> {
  try {
    return await emitFrontendCustomerIOEvent(payload);
  } catch (error) {
    console.warn("Customer.io frontend event was not recorded", {
      eventName: payload.event_name,
      error,
    });
    return null;
  }
}
